import { CheckIcon, Search } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { countryData } from "@/data/countryData";
import { useState } from "react";
import { Input } from "@/components/ui/input";

interface CountryListProps {
  selectedCountries: string[];
  onCountrySelect: (countryCode: string) => void;
}

export const CountryList = ({ selectedCountries, onCountrySelect }: CountryListProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  console.log("CountryList: Current selected countries:", selectedCountries);

  const countries = Object.entries(countryData)
    .map(([code, data]) => ({
      id: code,
      name: data.name,
      flag: data.flag,
      tier: data.tier,
    }))
    .filter(country => 
      country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      country.id.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .sort((a, b) => {
      if (a.tier !== b.tier) {
        return a.tier - b.tier;
      }
      return a.name.localeCompare(b.name);
    });

  const handleCountrySelect = (countryCode: string) => {
    console.log("CountryList: Selecting country:", countryCode);
    onCountrySelect(countryCode);
  };

  return (
    <div className="flex flex-col bg-background">
      <div className="p-2 border-b border-border">
        <div className="relative">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search countries..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-8 bg-background"
          />
        </div>
      </div>
      <ScrollArea className="h-[400px]">
        <div className="space-y-1 p-2">
          {countries.map((country) => (
            <button
              key={country.id}
              type="button"
              className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-muted hover:text-foreground cursor-pointer text-foreground bg-background"
              onClick={() => handleCountrySelect(country.id)}
            >
              <div className="flex h-4 w-4 items-center justify-center rounded-sm border border-primary">
                {selectedCountries.includes(country.id) && (
                  <CheckIcon className="h-3 w-3" />
                )}
              </div>
              <img 
                src={country.flag} 
                alt={`${country.name} flag`} 
                className="w-4 h-4 object-cover rounded-sm"
              />
              {country.name}
            </button>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};